module.exports = __webpack_public_path__ + "static/media/blog4_2.ae5f9bf1.png";